import { Loader2 } from "lucide-react";

import { cn } from "../../lib/utils";

type SpinnerPropsType = {
  className?: string;
  size?: "sm" | "md" | "lg";
};

const Spinner = ({ className, size = "md" }: SpinnerPropsType) => {
  const sizeClasses = {
    sm: "w-4 h-4",
    md: "w-6 h-6",
    lg: "w-8 h-8",
  };

  return (
    <Loader2 className={cn("animate-spin", sizeClasses[size], className)} />
  );
};

export { Spinner };
